// @ts-check

import {
	getUnscramblerResults,
	getWordlistResults,
} from "~/common/services/resultsService";

/**
 * The service endpoint provider
 * =============================
 *
 * Its main responsibility is to act as an entrypoint to retrieve different services,
 * so we can have a common interface to be used across the entire application.
 *
 * @param {import("@nuxtjs/axios").NuxtAxiosInstance} axios
 * @param {WF_Common.ConfigObject} config
 * @returns {WF_ServiceEndpointDictionary.Module}
 */
export const getServiceEndpointProvider = (axios, config) => ({
	callUnscramblerEndpoint: (params) =>
		getUnscramblerResults(axios, config, params),

	callWordlistEndpoint: (params) => getWordlistResults(axios, config, params),
});
